export default __webpack_public_path__ + "3294802cb8b76c7d3efb3116fc020eb2.svg";